export default "__VITE_ASSET__nmBZJSA$__"